import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchServiceById,
    clearSelectedService,
    createService,
    updateService,
} from "../redux/servicesSlice";

const ServiceEditorPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const loading = useSelector((state) => state.services.loading);
    const [form, setForm] = useState({ icon: "", title: "", content: "" });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    useEffect(() => {
        const fetchData = async () => {
            if (id) {
                try {
                    const service = await dispatch(fetchServiceById(id)).unwrap();
                    setForm({
                        icon: service.icon || "",
                        title: service.title || "",
                        content: service.content || "",
                    });
                } catch (err) {
                    console.error("Hizmet alınamadı:", err);
                }
            } else {
                setForm({ icon: "", title: "", content: "" });
            }
        };

        fetchData();
        return () => dispatch(clearSelectedService());
    }, [id, dispatch]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (id) {
                await dispatch(updateService({ id, updatedService: form })).unwrap();
                setSnackbar({ open: true, message: "Hizmet güncellendi!", severity: "success" });
            } else {
                await dispatch(createService(form)).unwrap();
                setSnackbar({ open: true, message: "Hizmet oluşturuldu!", severity: "success" });
            }
            setTimeout(() => navigate("/admin/services"), 1500);
        } catch (err) {
            console.error("İşlem başarısız:", err);
            setSnackbar({ open: true, message: "İşlem başarısız", severity: "error" });
        }
    };

    if (loading || (id && form.icon === "")) {
        return (
            <div className="d-flex justify-content-center mt-5">
                <div className="spinner-border text-primary" role="status" aria-hidden="true" />
                <span className="visually-hidden">Yükleniyor...</span>
            </div>
        );
    }

    return (
        <div className="container my-5" style={{ maxWidth: "720px" }}>
            <h2 className="fw-bold mb-4">{id ? "Hizmetu Düzenle" : "Yeni Hizmet Ekle"}</h2>
            <div
                className="p-4 rounded shadow-sm"
                style={{ backgroundColor: "rgba(255, 255, 255, 0.75)", backdropFilter: "blur(10px)" }}
            >
                <form onSubmit={handleSubmit}>
                    {/* Ad Soyad */}
                    <div className="mb-3">
                        <label htmlFor="icon" className="form-label">İcon</label>
                        <p>Lütfen "fas fa-tools" şeklinde yazınız. https://fontawesome.com/icons </p>
                        <input
                            type="text"
                            id="icon"
                            name="icon"
                            className="form-control"
                            value={form.icon}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Ünvan */}
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label">Başlık</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            className="form-control"
                            value={form.title}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Hizmet */}
                    <div className="mb-3">
                        <label htmlFor="content" className="form-label">Hizmet</label>
                        <textarea
                            id="content"
                            name="content"
                            className="form-control"
                            rows={5}
                            value={form.content}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <button type="submit" className="btn btn-primary rounded-pill px-4 py-2">
                        Gönder
                    </button>
                </form>
            </div>

            {/* Snackbar */}
            {snackbar.open && (
                <div
                    className={`toast align-items-center text-white bg-${snackbar.severity === "success" ? "success" : "danger"
                        } border-0 position-fixed bottom-0 start-50 translate-middle-x mb-4`}
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    style={{ zIndex: 1060 }}
                >
                    <div className="d-flex">
                        <div className="toast-body">{snackbar.message}</div>
                        <button
                            type="button"
                            className="btn-close btn-close-white me-2 m-auto"
                            onClick={() => setSnackbar({ ...snackbar, open: false })}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServiceEditorPage;
